import type { ReactNode } from 'react'
import logoFull from '@/assets/logo/logo-full.svg'
import { cn } from '@/lib/utils'

export interface LogoProps {
  className?: string

  alt?: string
}

export const Logo: React.FC<LogoProps> = ({ className, alt = 'SAAGA' }): ReactNode => (
  <img src={logoFull} alt={alt} className={cn('logo-full h-5 w-auto', className)} />
)
